export default __webpack_public_path__ + "static/media/amy-marie-headshot.0563948e.jpg";